import { connect } from 'react-redux'
import { compose, renderNothing, branch } from 'recompose'
import withToMarketExplore from 'src/composables/withToMarketExplore'
import { setCreateClientFrom } from 'src/actions/navigation'
import { selectHoShouldSeeMarketsNav } from 'src/store/selectors/navigation'
import { FROM } from 'src/constants/navigation'
import omitProps from 'src/composables/omitProps'

const MarketsContainer = compose(
  connect(
    state => ({
      show: selectHoShouldSeeMarketsNav(state)
    }),
    dispatch => ({
      onClick: () => {
        dispatch(setCreateClientFrom(FROM.MARKET_TAB))
      }
    })
  ),
  branch(({ show }) => !show, renderNothing),
  omitProps('show'),
  withToMarketExplore
)

export default MarketsContainer
